import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { FraudReviewPage } from "@/features/fraud-review";
import { fraudSearchSchema } from "@/features/fraud-review/fraud-route-search";

/** `?userId=` deep-links a row's dossier drawer, mirroring `/users?userId=`. */
export const Route = createFileRoute("/fraud/")({
  validateSearch: fraudSearchSchema,
  component: FraudRoute,
});

function FraudRoute() {
  return (
    <AdminDashboardShell>
      <FraudReviewPage />
    </AdminDashboardShell>
  );
}
